export default function VolumeLegend() {
	return (
		<div className="mt-5 pt-4 border-t border-white/10">
			<div className="text-sm text-gray-300 leading-relaxed mb-3 space-y-1">
				<div>
					<span className="font-semibold">SCENE:</span> Base volume from scene config
				</div>
				<div>
					<span className="font-semibold">LEVEL_GAIN:</span> User volume multiplier
					setting applied to scene
				</div>
				<div>
					<span className="font-semibold">OUT:</span> Current effective radio volume
				</div>
			</div>
			<div className="text-sm text-gray-400 font-medium">Press '2' to toggle</div>
		</div>
	);
}
